"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PullstateAsyncUtils = void 0;
exports.throwAsyncResult = throwAsyncResult;
exports.throwOrSuccessPayload = throwOrSuccessPayload;
const TaskFunctionResponses_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionResponses");
const TaskFunctionTypes_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionTypes");
const TaskFunctionUtils_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionUtils");
const pullstate_1 = require("pullstate");
function taskFunctionResponseToAsyncResponse(response) {
    return response.positive
        ? (0, pullstate_1.successResult)(response.payload)
        : (0, pullstate_1.errorResult)([response.endId, ...response.endTags], response.endMessage, response.errorPayload);
}
function asyncResponseToTaskFunctionErrorResponse(result) {
    return (0, TaskFunctionResponses_1.TFRFailureDefaults)({
        endId: result.tags?.[1] ?? TaskFunctionTypes_1.ETaskFunctionEndId.ERROR,
        endMessage: result.message,
        errorPayload: result,
        endTags: result.tags,
    });
}
function throwAsyncResult(result) {
    throw new TaskFunctionUtils_1.TaskFunctionError(asyncResponseToTaskFunctionErrorResponse(result));
}
function throwOrSuccessPayload(result) {
    if (result.error) {
        throwAsyncResult(result);
    }
    return result.payload;
}
exports.PullstateAsyncUtils = {
    taskFunctionResponseToAsyncResponse,
    asyncResponseToTaskFunctionErrorResponse,
    throwResult: throwAsyncResult,
};
